// src/pages/Reviews.jsx
import React, { useEffect, useState } from 'react';
import ReviewForm from '../components/ReviewForm';
import ReviewCard from '../components/ReviewCard';
import { apiUrl } from '../utils/api';

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchReviews = async () => {
    try {
      const response = await fetch(apiUrl('/api/reviews'));
      if (!response.ok) throw new Error('Failed to fetch reviews');
      const data = await response.json();
      setReviews(data);
    } catch (error) {
      console.error('Error fetching reviews:', error);

      // Fallback to static reviews
      setReviews([
        { id: 1, name: 'John Doe', rating: 5, comment: 'Amazing doctor! Highly recommended.' },
        { id: 2, name: 'Jane Smith', rating: 4, comment: 'Very professional and caring.' },
        { id: 3, name: 'Michael Johnson', rating: 5, comment: 'Helped me a lot with my anxiety.' },
        { id: 4, name: 'Emily Davis', rating: 5, comment: 'Dr. Nagesh is truly compassionate.' },
        { id: 5, name: 'Chris Brown', rating: 4, comment: 'Great experience, very helpful.' },
        { id: 6, name: 'Sophia Wilson', rating: 5, comment: 'Listens to all your concerns patiently.' },
        { id: 7, name: 'Liam Martinez', rating: 5, comment: 'I feel much better after the sessions.' },
        { id: 8, name: 'Olivia Garcia', rating: 4, comment: 'Knowledgeable and kind.' },
        { id: 9, name: 'Noah Rodriguez', rating: 5, comment: 'Helped me manage my stress effectively.' },
        { id: 10, name: 'Ava Hernandez', rating: 5, comment: 'Grateful for the guidance and support.' },
        { id: 11, name: 'Ethan Lee', rating: 4, comment: 'Provides practical advice and solutions.' },
        { id: 12, name: 'Isabella Walker', rating: 5, comment: 'Made me feel comfortable and safe.' },
        { id: 13, name: 'Mason Hall', rating: 5, comment: 'Highly recommend for mental health support.' },
        { id: 14, name: 'Mia Allen', rating: 4, comment: 'Very professional and effective approach.' },
        { id: 15, name: 'Lucas Young', rating: 5, comment: 'Helped me regain control of my life.' },
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  return (
    <div className="font-sans">
      <div className="max-w-5xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold mb-6 text-center">Patient Reviews</h1>

        <ReviewForm refreshReviews={fetchReviews} />

        {loading ? (
          <p className="text-center mt-6">Loading reviews...</p>
        ) : reviews.length === 0 ? (
          <p className="text-center mt-6 text-gray-600">No reviews yet. Be the first to write one!</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            {reviews.map((review) => (
              <ReviewCard
                key={review.id}
                name={review.name}
                rating={review.rating}
                comment={review.comment}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Reviews;
